import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { catchError, map, retry } from 'rxjs/operators'
import { AppConfigurationService } from './app-configuration.service'
import { SharedKey, SharedValue } from '../models/enum/shared.enum'
import { CustomPaginationType } from '../features/shared/custom-components/custom-pagination/modals/enum/custom-pagination.enum'
import { ISharedPagination } from '../models/interface/shared.interface'

@Injectable({
  providedIn: 'root'
})
export class BusinessUnitService {
  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService
  ) {}

  public getEndCustomerOrgUnit(unitId: string): Observable<any> {
    const baseSiteUrl: string = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/getEndCustomerOrgUnit/${unitId}`
    return this.http.get<any>(url).pipe(
      retry(1),
      catchError(() => {
        throw new Error(SharedValue.errorTryAgain)
      })
    )
  }

  public getEndUnits(params?: ISharedPagination): Observable<any> {
    let payload: HttpParams = new HttpParams()
      .set(SharedKey.fields, SharedValue.full)
      .set(SharedKey.pageSize, SharedValue.pageSize.toString())

    if (params?.pageNumber) {
      payload = payload.set(SharedKey.currentPage, params.pageNumber.toString())
    }
    if (params?.searchText) {
      payload = payload.set(SharedKey.searchText, params.searchText)
    }

    const baseSiteUrl: string = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/dispensers/endCustomers`
    return this.http.get<any>(url, { params: payload }).pipe(
      map((res) => {
        res.pagination.type = CustomPaginationType.CUSTOM
        return res
      }),
      retry(1),
      catchError(() => {
        return of(null)
      })
    )
  }
}
